module.exports = __webpack_public_path__ + "img/icon_disparo_de_comunicacoes.ab35369c.svg";